module.exports = __webpack_public_path__ + "media/shared/images/favicon-cb4389a94b5763f283b0a722232fea54.png";